import { render, staticRenderFns } from "./OrganizationChartLevelAreaList.vue?vue&type=template&id=2d87ef12&"
import script from "./OrganizationChartLevelAreaList.vue?vue&type=script&lang=js&"
export * from "./OrganizationChartLevelAreaList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports